"use client";

export default function imageLoader({ src, width, quality }) {
  const searchParams = new URLSearchParams();
  searchParams.set("url", src);
  searchParams.set("width", width);
  searchParams.set("quality", quality || 80);
  return `https://streams.frend.dev/image/v1?${searchParams.toString()}`;
}
